import React from 'react';
import {
  Card,
  CardHeader,
  Collapse,
  Switch,
  makeStyles,
  Typography,
  Grid,
} from '@material-ui/core';
import i18n from 'i18n';
import styles from './styles';

export interface ToggleCardProps {
  active?: boolean;
  children: React.ReactNode;
  customSubheader?: React.ReactNode;
  disable?: boolean;
  icon: React.ReactNode;
  id?: string;
  overrideClasses?: any;
  title: string | React.ReactNode;
  getActive?: (value: boolean) => void;
}

const ToggleCard = ({
  active = false,
  children,
  customSubheader,
  disable = false,
  icon,
  id,
  overrideClasses,
  title,
  getActive,
}: ToggleCardProps) => {
  const classes = makeStyles(styles(overrideClasses))();
  const [expanded, setExpanded] = React.useState(active);

  React.useEffect(() => {
    setExpanded(active);
  }, [active]);

  const handleGetActive = () => {
    setExpanded(props => !props);
    if (getActive) {
      getActive(expanded);
    }
  };

  return (
    <Card className={classes.container} data-testid={'autosky-togglecard'}>
      <CardHeader
        title={<Typography variant="h6">{title}</Typography>}
        avatar={icon}
        subheader={
          <Grid container alignItems="center" style={{ gap: '8px' }}>
            <Typography className={classes.subtitle}>
              {expanded ? i18n.t('ENABLED_KEY') : i18n.t('DISABLED_KEY')}
            </Typography>
            {customSubheader && (
              <>
                <Typography style={{ lineHeight: '18px' }}>{'• '}</Typography>{' '}
                {customSubheader}
              </>
            )}
          </Grid>
        }
        className={classes.cardTitle}
        action={
          <Grid className={classes.switchSpace}>
            <Switch
              id={id}
              disabled={disable}
              checked={expanded}
              onClick={handleGetActive}
              classes={{ colorSecondary: classes.switchChecked }}
              inputProps={{ 'aria-label': 'checkbox with default color' }}
              size="small"
            />
          </Grid>
        }
      />
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Card>
  );
};

export default ToggleCard;
